'use strict';

class fadeToggle {
  constructor($target, duration = 400, delay = 40) {
    if (window.getComputedStyle($target).display === 'none') {
      this._fadeIn($target,duration,delay);
    } else {
      this._fadeOut($target,duration,delay);
    };
  };
  _fadeOut = (el, duration, delay) => {
    const coef = 1 / (duration / delay);
    el.style.opacity = 1.0;
    let opacity = Number(el.style.opacity);
    const animation = setInterval(() => {
      opacity -= coef;
      el.style.opacity = opacity;
      if (opacity <= 0) {
        el.style.display = 'none';
        clearInterval(animation);
      };
    }, delay);
  };
  _fadeIn = (el, duration, delay) => {
    const coef = 1 / (duration / delay);
    el.style.display = 'block';
    el.style.opacity = 0;
    let opacity = Number(el.style.opacity);
    const animation = setInterval(() => {
      opacity += coef;
      el.style.opacity = opacity;
      if (opacity >= 1) {
        clearInterval(animation);
      };
    }, delay);
  };
};

class slideToggle {
  constructor($target, duration = 400) {
    if (window.getComputedStyle($target).display === 'none') {
      this._slideDown($target, duration);
    } else {
      this._slideUp($target, duration);
    };
  };
  _slideUp = (el, duration) => {
    el.style.height = el.offsetHeight+'px';
    el.offsetHeight;
    el.style.transitionProperty = 'height,margin,padding';
    el.style.overflow = 'hidden';
    el.style.height = 0;
    el.style.paddingTop = 0;
    el.style.paddingBottom = 0;
    el.style.marginTop = 0;
    el.style.marginBottom = 0;
    el.style.transitionDuration = `${duration}ms`;
    el.style.transitionTimingFunction = 'ease';
    setTimeout(() => {
      el.style.display = 'none';
      el.style.removeProperty('height');
      el.style.removeProperty('padding-top');
      el.style.removeProperty('padding-bottom');
      el.style.removeProperty('margin-top');
      el.style.removeProperty('margin-bottom');
      el.style.removeProperty('overflow');
      el.style.removeProperty('transition-duration');
      el.style.removeProperty('transition-property');
      el.style.removeProperty('transition-timing-function');
    }, duration);
  };
  _slideDown = (el, duration) => {
    el.style.removeProperty('display');
    let display = window.getComputedStyle(el).display;
    if (display === 'none') display = 'block';
    el.style.display = display;
    let height = el.offsetHeight;
    el.style.overflow = 'hidden';
    el.style.height = 0;
    el.style.paddingTop = 0;
    el.style.paddingBottom = 0;
    el.style.marginTop = 0;
    el.style.marginBottom = 0;
    el.offsetHeight;
    el.style.transitionProperty='height,margin,padding';
    el.style.height = `${height}px`;
    el.style.transitionDuration = `${duration}ms`;
    el.style.transitionTimingFunction = 'ease';
    el.style.removeProperty('padding-top');
    el.style.removeProperty('padding-bottom');
    el.style.removeProperty('margin-top');
    el.style.removeProperty('margin-bottom');
    setTimeout(() => {
      el.style.removeProperty('height');
      el.style.removeProperty('overflow');
      el.style.removeProperty('transition-duration');
      el.style.removeProperty('transition-property');
      el.style.removeProperty('transition-timing-function');
    }, duration);
  };
};

class modalStock {
  constructor () {
    this.$body = document.body;
    this.$t = document.querySelector('#modal-stock');
    this.$content = this.$t.querySelector('.modal-stock-content');
    this.$triggers = document.querySelectorAll('[aria-controls=modal-stock]');
    this.$selectTrigger = document.querySelector('.modal-stock-select__trigger');
    this.$variants = document.querySelector('#modal-stock-variants');
    this.$variantsTriggers = document.querySelectorAll('[aria-controls=modal-stock-variants]');
    this.$variantButtons = document.querySelectorAll('.modal-stock-variant__btn');
    this.$region = document.querySelector('.modal-stock-region');
    this.$regionLinksHash = this.$region.querySelectorAll('.modal-stock-region__lists__item > a[href^="#"]');
    this.$loading = document.createElement('div');
    this.$loading.classList.add('modal-stock-loading');
    this.$loading.setAttribute('aria-hidden', true);
    this.isExpanded = false;
    this.isVariantsHidden = true;
    this.isVariantsExpanded = false;
    this.isHidden = true;
    this.inventoryUrl = 'https://himiko-ec.com/store_inventory_data/stock.php';
    this.shoplistUrl = '/pages/json-shoplist?type=load-ajax';
    this.queryParameter = {
      product: '',
      variant1: '',
      variant2: ''
    };
    this.regionArr = [];
    this.inventoryShopArr = [];

    this.$content.appendChild(this.$loading);

    this.$triggers.forEach($trigger => {
      $trigger.addEventListener('click', event => {
        event.preventDefault();
        this._openClose();
      });
    });

    this.$variantsTriggers.forEach($trigger => {
      $trigger.addEventListener('click', event => {
        event.preventDefault();
        this._variantsToggle();
      });
    });

    this._getShopList();
    this._variantSelect();
    this._regionLinks();
  };
  _openClose = () => {
    if (this.isExpanded === false) {
      this.isExpanded = true;
      this.isHidden = false;
    } else {
      this.isExpanded = false;
      this.isHidden = true;
    };
    this.$triggers.forEach($trigger => {
      $trigger.setAttribute('aria-expanded', this.isExpanded);
    });
    this.$t.setAttribute('aria-hidden', this.isHidden);
  };
  _variantsToggle = () => {
    if (this.isVariantsExpanded === false) {
      this.isVariantsExpanded = true;
      this.isVariantsHidden = false;
    } else {
      this.isVariantsExpanded = false;
      this.isVariantsHidden = true;
    };
    this.$variantsTriggers.forEach($trigger => {
      $trigger.setAttribute('aria-expanded', this.isVariantsExpanded);
    });
    this.$variants.setAttribute('aria-hidden', this.isVariantsHidden);
    new slideToggle(this.$variants);
  };
  _variantSelect = () => {
    this.$variantButtons.forEach($btn => {
      let text = $btn.textContent;
      let sku = $btn.dataset.sku;
      let product = sku.replace(/^([0-9]{6})([0-9]+)/, '$1');
      product = `00${product}`;
      let variant = sku.replace(/^([0-9]{6})([0-9]+)/, '$2');
      let variant1 = variant.replace(/^([0-9]+)([0-9]{3})$/, '$1');
      variant1 = variant1 < 10 ? `00${variant1}` :  `0${variant1}`;
      let variant2 = variant.replace(/^([0-9]+)([0-9]{3})$/, '$2');
      variant2 = `0${variant2}`;
      $btn.addEventListener('click', event => {
        event.preventDefault();
        if (!$btn.classList.contains('is-active')) {
          this.queryParameter = {
            product: product,
            variant1: variant1,
            variant2: variant2,
          };
          this.$variantButtons.forEach($otherBtn => {
            $otherBtn.classList.remove('is-active');
          });
          $btn.classList.add('is-active');
          this.$selectTrigger.textContent = text;
          this.$loading.setAttribute('aria-hidden', false);
          this._getStockJson();
        };
        this._variantsToggle();
      });
    });
  };
  _regionLinks = () => {
    this.$regionLinksHash.forEach($link => {
      $link.addEventListener('click', event => {
        event.preventDefault();
        let hash = $link.getAttribute('href');
        hash = hash.replace(/^#([\d\D]+)/, '$1');
        let $hash = document.getElementById(hash);
        if ($hash) $hash.scrollIntoView({ behavior: 'smooth' });
        return false;
      });
    });
  };
  _getShopList = () => {
    fetch(this.shoplistUrl).then(response => {
      if (!response.ok) {
        throw new Error(`Status: ${response.status}`);
      };
      return response.text();
    }).then(html => {
      const parser = new DOMParser();
      const $document = parser.parseFromString(html, 'text/html');
      stockRegionArr.forEach(region => {
        let name = region.name;
        let spell = region.spell;
        let $json = $document.querySelector(`#json-${spell}`);
        this.regionArr[spell] = {
          name: name,
          json: ''
        };
        if ($json) {
          let jsonldText = $json.innerText;
          jsonldText = jsonldText.replace(/\t/g, '');
          let json = JSON.parse(jsonldText);
          this.regionArr[spell].json = json;
        };
      });
    }).catch(error => console.error(error));
  };
  _getStockJson = () => {
    const arrangeParams = Object.fromEntries(Object.entries(this.queryParameter).filter(([,v])=>v!==undefined));
    const urlSearchParams = new URLSearchParams(arrangeParams);
    const url = `${this.inventoryUrl}?${urlSearchParams}`;
    fetchJsonp(url).then(response => {
      return response.json();
    }).then(response => {
      this.$loading.setAttribute('aria-hidden', true);
      this.inventoryShopArr = [];
      const responseData = response.data;
      let baseShopArr = [];
      if (responseData.length) {
        // 在庫csvの倉庫コードと同じ店舗情報を配列化
        for (let spell in this.regionArr) {
          let region = this.regionArr[spell];
          let jsonShopArr = region.json.shop;
          if (jsonShopArr.length) {
            jsonShopArr.map(shop => {
              let storageObj = responseData.find(data => data.storage === shop.storage);
              if (storageObj != undefined) {
                if (baseShopArr[spell] === undefined) {
                  baseShopArr[spell] = {
                    json: []
                  };
                };
                shop.stock = storageObj.stock;
                baseShopArr[spell].json.push(shop);
              };
            });
          };
        };

        // 同名の店舗の場合「卑弥呼」を表示
        for (let spell in baseShopArr) {
          if (baseShopArr[spell].json) {
            let shops = baseShopArr[spell].json.map(shop => shop.name && shop.storage);
            let hasDuplicate = new Set(shops).size !== shops.length;
            if (hasDuplicate) {
              let newShopArr = [];
              baseShopArr[spell].json.forEach((shop, index) => {
                let sameShop = baseShopArr[spell].json.find((other, otherIndex) => otherIndex !== index && other.name === shop.name && other.storage === shop.storage);
                if (sameShop !== undefined && shop.tab !== '卑弥呼') {
                } else {
                  newShopArr.push(shop);
                };
              });
              baseShopArr[spell].json = newShopArr;
            };
          };
        };
        this.inventoryShopArr = baseShopArr;
      };
      this._createShopList();
    }).catch(error => {
      console.error(error);
    });
  };
  _createShopList = () => {
    let elm = String();
    elm += String()
      + '<ul class="modal-stock-region__lists">'
    ;
    stockRegionArr.forEach(region => {
      let name = region.name;
      let spell = region.spell;
      let hasShop = this.inventoryShopArr[spell];
      elm += String()
        + '<li class="modal-stock-region__lists__item">'
          + (hasShop ? `<a href="#stock-region-${spell}">` : '<span>')
            + name
          + (hasShop ? `</a>` : '</span>')
        + '</li>'
      ;
    });
    elm += String()
      + '</ul>'
    ;
    elm += String()
      + '<div class="modal-stock-region__content">'
    ;
    stockRegionArr.forEach(region => {
      let name = region.name;
      let spell = region.spell;
      let shopArr = this.inventoryShopArr[spell];
      if (shopArr) {
        let shopJson = shopArr.json;
        elm += String()
          + `<div id="stock-region-${spell}" class="modal-stock-region__block">`
            + `<p class="modal-stock-region__block__title">${name}</p>`
            + '<div class="modal-stock-region__shop">'
        ;
        shopJson.forEach(shop => {
          let labelElm = String();
          let brandlElm = String();
          let stockElm = String();
          let googleElm = String();
          let telElm = String();
          let buttonElm = String();
          if (shop.label) {
            labelElm += String()
              + '<ul class="label">'
            ;
            shop.label.forEach(label => {
              labelElm += String()
                + `<li>${label}</li>`
              ;
            });
            labelElm += String()
              + '</ul>'
            ;
          };
          if (shop.brand) {
            brandlElm += String()
              + '<div class="shop_brand">'
                + '<h5><span>取り扱いブランド</span></h5>'
                + '<ul class="brand">'
            ;
            shop.brand.forEach(brand => {
              brandlElm += String()
                + `<li>${brand}</li>`
              ;
            });
            brandlElm += String()
                + '</ul>'
              + '</div>'
            ;
          };
          stockElm += String()
            + '<p class="aw-shoplist-shop__stock">'
          ;
          if (shop.stock >= 3) {
            stockElm += String()
              + '在庫あり'
            ;
          } else {
            stockElm += String()
              + `残り${shop.stock}点`
            ;
          };
          stockElm += String()
            + '</p>'
          ;
          if (shop.google_link) {
            googleElm += String()
              + `<div class="btn google"><a class="button inversion" href="${shop.google_link}" target="_blank" rel="noopener">Google Maps</a></div>`
            ;
          };
          if (shop.tel) {
            telElm += String()
              + `<div class="btn tel"><a class="button inversion" href="${shop.tel_link}" target="_blank" rel="noopener">${shop.tel}</a></div>`
            ;
          };
          if (shop.button_url) {
            buttonElm += String()
              + `<div class="btn site"><a class="button inversion" href="${shop.button_url}" target="_blank" rel="noopener">${shop.button_text}</a></div>`
            ;
          };
          elm += String()
            + '<div class="aw-shoplist-shop">'
              + '<div class="left_box">'
                + '<div class="left_box_content">'
                  + '<div class="shop_title">'
                    + `<p class="aw-shoplist-shop__name">${shop.name}</p>`
                    + labelElm
                  + '</div>'
                  + '<div class="shop_address">'
                    + shop.address
                    + (shop.bill ? `<br>${shop.bill}` : '')
                  + '</div>'
                  + stockElm
                + '</div>'
                + brandlElm
              + '</div>'
              + '<div class="right_box">'
                  + googleElm
                  + telElm
                  + buttonElm
              + '</div>'
            + '</div>'
          ;
        });
        elm += String()
            + '</div>'
          + '</div>'
        ;
      };
    });
    elm += String()
      + '</div>'
    ;
    this.$region.innerHTML = elm;
  };
};

const $modalStock = document.querySelector('#modal-stock');
if ($modalStock) new modalStock();
